import { useEffect, useState } from "react";

import { useHistory, useLocation } from "react-router-dom";

import { FullScreenRouterState } from "./useFullScreenNavigate";

export const useFullScreenClose = () => {
    const history = useHistory();

    const { state, pathname, search } = useLocation<FullScreenRouterState>();

    // Retain the initial state when the full screen page was created
    const [memoState] = useState<FullScreenRouterState>(state);

    // Overrides the exit location with the original entry point if a user moves between pages within the full screen page
    useEffect(() => {
        if (memoState?.originLocation) {
            history.replace(
                { pathname, search },
                { ...state, originLocation: memoState.originLocation },
            );
        }
        // Only run when path changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return () => history.push(memoState?.originLocation ?? "/");
};
